import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'

import styles from 'src/styles/common.module.scss'

const BREAKPOINT_RULES: Record<string, string[]> = {
    desktop: ['πάρτε'],
    small: ['εισιτήρια', 'πάρτε'],
}

export const TextHeaderEl = () => {
    const isDesktop = useMediaQuery('(min-width: 768px)')

    let breakAfterWords = BREAKPOINT_RULES.small

    if (isDesktop) {
        breakAfterWords = BREAKPOINT_RULES.desktop
    }

    return (
        <HighlightedText
            text="Ξύστε τα εισιτήρια και πάρτε το μπόνους σας"
            highlights={[{ word: 'το' }, { word: 'μπόνους' }, { word: 'σας' }]}
            breakAfterWords={breakAfterWords}
            className={styles.text_header}
        />
    )
}
